import React from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const LinkIcon = () => <FontAwesomeIcon icon={["fas", "link"]} />

export default LinkIcon;
